import { actions as formActions } from 'react-redux-form';

import CommunicationWorkflowDuck from './CommunicationWorkflowDuck';

import { entity as mmsSnippets } from '../ducks/mmsSnippets';
import { actions as customerActions } from '../ducks/customer';
import { getTokens as getTokensAction } from '../actions/tokens';
import { createMMS, previewMMS } from '../actions/mms';
import relatedContacts from '../actions/relatedContacts';

export default class MMSWorkflowDuck extends CommunicationWorkflowDuck {
  constructor() {
    super();

    this.name = 'mmsWorkflow';

    this.defaultModelState = {
      mms: {snippet: {body: ''}, recipients: []},
      contacts: {relation: [], contact_ids: []}
    };

    this.actions = this.actions.bind(this);
    this.getCustomer = this.getCustomer.bind(this);
    this.getRelatedContacts = this.getRelatedContacts.bind(this);
    this.getTokens = this.getTokens.bind(this);
    this.sendMMS = this.sendMMS.bind(this);
    this.setPreviewRecipientId = this.setPreviewRecipientId.bind(this);
    this.setRecipients = this.setRecipients.bind(this);
    this.setSnippet = this.setSnippet.bind(this);
    this.validateSnippet = this.validateSnippet.bind(this);
  }

  actions() {
    return Object.assign({}, super.actions(), {
      getCustomer: this.getCustomer,
      getRelatedContacts: this.getRelatedContacts,
      getTokens: this.getTokens,
      sendMMS: this.sendMMS,
      setPreviewRecipientId: this.setPreviewRecipientId,
      setSnippet: this.setSnippet,
      validateSnippet: this.validateSnippet
    });
  }

  getCustomer() {
    return (dispatch) => dispatch(customerActions.load());
  }

  getRelatedContacts(model, recipientFilter, schoolYearId, combineFamilyContacts) {
    return (dispatch) => {
      return dispatch(formActions.submitFields(`${this.name}.model.contacts`,
        dispatch(relatedContacts(model.relation || [], model.contact_ids, null, combineFamilyContacts))
          .then((response) => {
            const recipients = this.createRecipientsList(response, recipientFilter);

            dispatch(formActions.change(`${this.name}.model.mms.recipients`, recipients));

            return Promise.resolve(response);
          })
          // We catch and re-reject to deference the errors. Ugly.
          .catch((response) => Promise.reject(response.errors))
        )
      )
    }
  };

  getTokens() {
    return (dispatch) => {
      return dispatch(getTokensAction('mms')).then((response) => {
        dispatch(formActions.change(`${this.name}.model.mms.snippet.tokens`, response.tokens));
      });
    }
  };

  sendMMS(recipients, snippet) {
    return (dispatch) => {
      //noinspection JSUnusedLocalSymbols
      const {tokens, ...dupSnippet} = snippet;

      dispatch(formActions.setPending(`${this.name}.model.mms`));

      return dispatch(createMMS({recipients: recipients, snippet: dupSnippet}));
    }
  };

  setPreviewRecipientId(previewContact, snippet) {
    return (dispatch) => {
      dispatch({type: this.types().SET_PREVIEW_CONTENT, previewContent: null});

      dispatch(previewMMS({
        recipients: [previewContact],
        snippet
      }))
        .then((response) => dispatch(this.setPreviewContent(response.snippet_preview[0])));

      return dispatch({type: this.types().SET_ACTIVE_PREVIEW, previewRecipientId: previewContact.id});
    }
  };

  setRecipients(contactIds) {
    return (dispatch) => dispatch(
      formActions.change(`${this.name}.model.contacts.contact_ids`, contactIds)
    )
  };

  setSnippet(snippet, customer) {
    return (dispatch) => (
      dispatch(mmsSnippets.actions.get(snippet.id))
        .then(({entities}) => {
          const selectedSnippet = entities.mmsSnippets[snippet.id];
          const newModel = {
            body: selectedSnippet.body,
            tokens: selectedSnippet.tokens
          };

          return dispatch(formActions.change(`${this.name}.model.mms.snippet`, newModel))
        })
    )
  };

  validateSnippet(snippet) {
    return (dispatch) => {
      //noinspection JSUnusedLocalSymbols
      const {tokens, ...dupValues} = snippet;

      dupValues.validate = true;

      return dispatch(formActions.submitFields(`${this.name}.model.mms.snippet`,
        dispatch(mmsSnippets.actions.validate(dupValues))
        // We catch and re-reject to deference the errors. Ugly.
          .catch((response) => {
            return Promise.reject(response.errors);
          })
      ));
    }
  };
}
